export const getTradeIdeas = (state) => {
  return state.tradeIdeas;
};

export const getHistoryTradeIdeas = (state) => {
  return state.historyTradeIdeas;
};

export const isLoading = (state) => {
  return state.isLoading;
};
